import { useEffect } from 'react';

interface Props {
  prizeName: string;
  imageUrl?: string | null;
  body?: string;
  onFinished: () => void;
}

/**
 * ハニトー演出（提案資料 p.8）。
 *
 *   1. スタッフがスタンプを押す → 画面中央にパンが空から降ってくる
 *   2. 蜂蜜がトロッとアニメーションでパンの上を流れる
 *   3. 「ハニトー完成」のエフェクトと共に特典名が現れる
 *   4. スタンプが確定 → 電子クーポンが保存される
 *
 * 画像は管理画面で差し替えられる。ここでは画像未設定時のフォールバック表現を置いている。
 * 実際のアニメーション素材（Lottie 等）は未確定（docs/todo.txt T-07）。
 */
export function HoneyToastEffect({ prizeName, imageUrl, body, onFinished }: Props): JSX.Element {
  useEffect(() => {
    const timer = setTimeout(onFinished, 2600);
    return () => clearTimeout(timer);
  }, [onFinished]);

  return (
    <div className="card center">
      <div className="honey">
        {imageUrl ? (
          <img className="hero-image" src={imageUrl} alt="" />
        ) : (
          <>
            <div className="honey__drizzle" />
            <div className="honey__toast" aria-hidden>
              🍞
            </div>
          </>
        )}
        <div className="honey__label">ハニトー完成！</div>
      </div>
      <h2>{prizeName}</h2>
      <p className="muted">{body || '特典が確定しました'}</p>
    </div>
  );
}
